// This is an example -> It is the default styles file from the default Chakra theme
// https://github.com/chakra-ui/chakra-ui/blob/main/packages/theme/src/styles.ts

const styles = {
  // global: {
  //   body: {
  //     fontFamily: "body",
  //     color: "chakra-body-text",
  //     bg: "chakra-body-bg",
  //     transitionProperty: "background-color",
  //     transitionDuration: "normal",
  //     lineHeight: "base",
  //   },
  //   "*::placeholder": {
  //     color: "chakra-placeholder-color",
  //   },
  //   "*, *::before, &::after": {
  //     borderColor: "chakra-border-color",
  //     wordWrap: "break-word",
  //   },
  // },
}

export default styles
